import { ItemRestraints } from '@core/shared/restraints';
export class SceneUserProgressRestraints extends ItemRestraints {
  canCreateItem(item) {
    if (this.currentUserIsOwner(item)) return true;
    return this.requireRole('ADMINISTRATOR');
  }
  canViewItem(item) {
    if (this.currentUserIsOwner(item)) return true;
    return this.requireRole('ADMINISTRATOR');
  }
  canUpdateItem(item, oldItem) {
    if (this.currentUserIsOwner(item)) return true;
    return this.requireRole('ADMINISTRATOR');
  }
  canRemoveItem(item) {
    if (this.isExecutedBySystem()) return true;
    if (this.currentUserIsOwner(item)) return true;
    return this.requireRole('ADMINISTRATOR');
  }
}